<div class="sidebar toggled">
  <div class="sidebar-area scrollbar">
    <nav class="sidebar-nav">
      <!-- new navigation components here, not fully implemented -->
      <!--
      <app-nav-list [list]='menu' [listClasses]='{"main-menu": true, "nav":false, "in":false, "side-menu":false}'></app-nav-list>
      <hr>
      -->
      <ul class="nav in side-menu">
        <li class="menu-item-has-children current-page">
          <a routerLink="/jobs" routerLinkActive="active" onclick="reloadMenu()">
            <i class="fas fa-building"></i>
            <span>Jobs</span></a
          >
          <ul class="list-unstyled sub-menu">
            <li class="hide">
              <a routerLink="/jobs" routerLinkActive="active" onclick="reloadMenu()" class="cpage-link">Jobs</a>
            </li>
            <li><a routerLink="/jobs/status" routerLinkActive="active" onclick="reloadMenu()">Job Status</a></li>
            <li *ngIf="userPermissions && userPermissions?.invoicing_list?.view">
              <a routerLink="/jobs/invoices" routerLinkActive="active" onclick="reloadMenu()">Invoicing</a>
            </li>
            <li><a routerLink="/owner_info" routerLinkActive="active" onclick="reloadMenu()">Owner Info</a></li>
            <li><a routerLink="/customers" routerLinkActive="active" onclick="reloadMenu()">Customers</a></li>
          </ul>
        </li>
        <li
          *ngIf="
            (userPermissions && userPermissions?.tool_models?.view) || (userPermissions && userPermissions?.tools?.view)
          "
          class="menu-item-has-children">
          <a routerLink="/tools" routerLinkActive="active" onclick="reloadMenu()">
            <i class="fas fa-tools"></i>
            <span>ToolPointe</span></a
          >
          <ul class="list-unstyled sub-menu">
            <li class="hide">
              <a routerLink="/tools" routerLinkActive="active" onclick="reloadMenu()" class="cpage-link">Tools</a>
            </li>
            <li><a routerLink="/tools/models" routerLinkActive="active" onclick="reloadMenu()">Models</a></li>
            <li><a routerLink="/tools/transfers" routerLinkActive="active" onclick="reloadMenu()">Transfers</a></li>
            <li><a routerLink="/tools/inventory" *ngIf="userPermissions?.tool_inventory?.view" routerLinkActive="active" onclick="reloadMenu()">Inventory</a></li>
          </ul>
        </li>
        <li class="menu-item-has-children" *ngIf="userPermissions?.job_pointe?.view === 1">
          <ng-container>
            <a
              class="jobPointe-menu"
              [routerLink]="determineJobPointeLink()"
              routerLinkActive="active"
              onclick="reloadMenu()">
              <i class="fas fa-briefcase"></i>
              <span>Job Pointe</span>
            </a>
            <ul class="list-unstyled sub-menu">
              <li class="hide">
                <a
                  [routerLink]="determineJobPointeLink()"
                  routerLinkActive="active"
                  onclick="reloadMenu()"
                  class="cpage-link"
                  >Job Pointe</a
                >
              </li>
              <li *ngIf="userPermissions?.job_board_attributes?.view === 1 && userPermissions?.job_pointe?.view === 1">
                <a routerLink="/job-pointe/job-board" routerLinkActive="active" onclick="reloadMenu()">Job Board</a>
              </li>
              <li *ngIf="userPermissions?.manage_jobs?.view === 1 && userPermissions?.job_pointe?.view === 1">
                <a routerLink="/job-pointe/manage-jobs" routerLinkActive="active" onclick="reloadMenu()">Manage Jobs</a>
              </li>
              <li *ngIf="userPermissions?.job_pointe_employees?.view === 1 && userPermissions?.job_pointe?.view === 1">
                <a routerLink="/job-pointe/employees" routerLinkActive="active" onclick="reloadMenu()">Employees</a>
              </li>
              <li *ngIf="userPermissions?.job_pointe_configuration?.view === 1 && userPermissions?.job_pointe?.view === 1">
                <a routerLink="/job-pointe/configuration/attributes" routerLinkActive="active" onclick="reloadMenu()">Configuration</a>
              </li>
            </ul>
          </ng-container>
        </li>
        <li>
          <a
            [href]="purchasePointeUrl"
            target="_blank"
            data-toggle="sidebar-tooltip"
            data-placement="left"
            title="PurchasePointe"
            ><i class="fas fa-external-link"></i> <span>PurchasePointe</span></a
          >
        </li>
        <li>
          <a
            href="https://andyegan.sharepoint.com/sites/EganIntranet"
            target="_blank"
            data-toggle="sidebar-tooltip"
            data-placement="left"
            title="Intranet"
            ><i class="fas fa-external-link"></i> <span>Intranet</span></a
          >
        </li>
        <li class="menu-item-has-children">
          <a
            class="links-menu"
            href="javascript:void(0);"
            onclick="reloadLinkMenu('.links-menu')"
            data-toggle="sidebar-tooltip"
            data-placement="left"
            title="Links"
            ><i class="fas fa-link"></i> <span>Links</span></a
          >
          <ul class="list-unstyled sub-menu">
            <!-- <li class="hide">
              <a href="javascript:void(0);" onclick="reloadLinkMenu()" class="cpage-link">Links</a>
            </li> -->
            <li>
              <a href="https://andyegan.hh2.com/" target="_blank">
                <i class="fas fa-external-link"></i>
                <span>HH2</span>
              </a>
            </li>
            <li>
              <a
                href="https://accounts.zoho.com/signin?servicename=ZohoHome&amp;signupurl=https://www.zoho.com/signup.html"
                target="_blank">
                <i class="fas fa-external-link"></i>
                <span>ZOHO</span>
              </a>
            </li>
            <li>
              <a href="https://login.msuite.com" target="_blank">
                <i class="fas fa-external-link"></i>
                <span>FabPro</span>
              </a>
            </li>
            <li>
              <a href="https://acc.autodesk.com/login" target="_blank">
                <i class="fas fa-external-link"></i>
                <span>AD BUILD</span>
              </a>
            </li>
          </ul>
        </li>
        <li class="menu-item-has-children">
          <a
            class="settings-menu"
            href="javascript:void(0);"
            onclick="reloadLinkMenu('.settings-menu')"
            data-toggle="sidebar-tooltip"
            data-placement="left"
            title="Settings"
            ><i class="fas fa-cog"></i> <span>Settings</span></a
          >
          <ul class="list-unstyled sub-menu">
            <li *ngIf="userPermissions && userPermissions?.roles_setting?.view">
              <a routerLink="/settings/roles" routerLinkActive="active" onclick="reloadMenu()">
                <i class="far fa-clipboard"></i>
                <span>Roles</span>
              </a>
            </li>
            <li *ngIf="userPermissions && userPermissions?.system_users_setting?.view">
              <a routerLink="/settings/system_users" routerLinkActive="active" onclick="reloadMenu()">
                <i class="far fa-users"></i>
                <span>System Users</span>
              </a>
            </li>
            <li *ngIf="userPermissions && userPermissions?.union_locals_setting?.view">
              <a routerLink="/settings/union_locals" routerLinkActive="active" onclick="reloadMenu()">
                <i class="far fa-users-class"></i>
                <span>Union Locals</span>
              </a>
            </li>
            <li *ngIf="userPermissions && userPermissions?.tools_setting?.view">
              <a
                *ngIf="menu[8].children[3].show"
                routerLink="/settings/tools"
                routerLinkActive="active"
                onclick="reloadMenu()"
                data-toggle="sidebar-tooltip"
                data-placement="left"
                title="Tools">
                <i class="far fa-tools"></i>
                <span>Tools</span>
              </a>
            </li>
            <li *ngIf="userPermissions && userPermissions?.design_setting?.view">
              <a routerLink="/settings/design" routerLinkActive="active" onclick="reloadMenu()">
                <i class="far fa-drafting-compass"></i>
                <span>Design</span>
              </a>
            </li>
            <li *ngIf="userPermissions && userPermissions?.smtp_setting?.view">
              <a routerLink="/settings/smtp" routerLinkActive="active" onclick="reloadMenu()">
                <i class="far fa-file-signature"></i>
                <span>SMTP</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>

  <a href="javascript:;" class="collapse-sidebar-button" onclick="collapseSidebarButton()">
    <i class="fas fa-chevron-double-left"></i>
    <span>Collapse sidebar</span>
  </a>
</div>
